class AttentiveInjectCSS {
  constructor () {
    this.injected = false
    this.observeEnvolve()
    this.observeBody()
  }

  observeEnvolve () {
    const observer = new MutationObserver(() => {
      const envolve = document.querySelector('envolve-vsa')
      if (envolve && envolve.shadowRoot && !this.injected) {
        this.injectCSS(envolve.shadowRoot)
        this.syncAttributes(envolve)
        this.injected = true
        observer.disconnect()
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
  }

  observeBody () {
    const updateAttributes = () => {
      const envolve = document.querySelector('envolve-vsa')
      if (envolve) this.syncAttributes(envolve)
    }
    updateAttributes()
    const observer = new MutationObserver(updateAttributes)
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  syncAttributes (envolve) {
    envolve.toggleAttribute(
      'data-fixedbar-collection',
      document.body.classList.contains('lyt-Theme-collection') &&
        document.body.classList.contains('util-FixedBar-active'),
    )
    envolve.toggleAttribute(
      'data-fixedbar-product',
      document.body.classList.contains('lyt-Theme-product') &&
        document.body.classList.contains('util-FixedBar-active'),
    )
  }

  injectCSS (shadowRoot) {
    const style = document.createElement('style')
    style.textContent = `
      #envolve-launcher {
        bottom: 15px !important;
        right: 15px !important;
        transition: bottom 0.5s ease, box-shadow 0.5s !important;
      }
      :host([data-fixedbar-collection]) #envolve-launcher {
        bottom: 72px !important;
      }
      @media (min-width:900.02px) {
        :host([data-fixedbar-collection]) #envolve-launcher {
          bottom: 15px !important;
        }
      }
      :host([data-fixedbar-product]) #envolve-launcher {
        bottom: 70px !important;
      }
      @media (min-width:900.02px) {
        :host([data-fixedbar-product]) #envolve-launcher {
          bottom: 110px !important;
        }
      }
`
    shadowRoot.appendChild(style)
  }
}

if (!window.AttentiveInjectCSS) {
  window.AttentiveInjectCSS = new AttentiveInjectCSS()
}
